module.exports = __webpack_public_path__ + "img/JillianMichaelsBodyShred.ffe5a306.jpeg";